<template>
    <div>
        <nav>
            <ul>
                <li>
                    <router-link to="/home" active-class="active">博客</router-link>
                    <router-link to="/add" active-class="active">写博客</router-link>
                </li>
            </ul>
        </nav>
    </div> 
</template>

<script>
export default {
    name: 'blog-header',

}
</script>

<style>
/* 只对HTML标签有意义,如 a {} 
没有点样式名称是跟标签是相对应的，
但是这样写并没有特指某个标签，而是指的页面内所有<p>标签的样式 */
nav{
    background-color: tomato;
    padding: 30px 0;
    margin-bottom: 40px;
}
/* 加list-style:none去掉li默认产生”点“ */
ul{
    list-style-type: none;
    text-align: center;
    margin: 0;
}
li{
    display: inline-block;
    margin: 0 10px;
}
a{
    color: white;
    text-decoration: none;
    padding: 12px;
    border-radius: 5px;
}

.active{
    background-color: rgba(255,255, 255, 0.8);
    color: #444
}
</style>


// WEBPACK FOOTER //
// src/components/BlogHeader.vue